// components/Layout.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';

const Layout = ({ children }) => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <div className="min-h-screen bg-gray-100 app-shell">
      <div className="main-content">
        {children}
      </div>
      <footer className="app-footer">
        {t('footer.copyright', { year })}
      </footer>
    </div>
  );
};

export default Layout;
